/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */


import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeCategoryModal } from "../../Store/Slices/categorySlice";
import AddCategory from "./AddCategory";
import EditCategory from "./EditCategory";
import DeleteCategory from "./DeleteCategory";

const CategoryDialog = () => {

    const dispatch = useDispatch();
    const category = useSelector((state) => state.category);

    let content;
    let deleteView = false

    const roles = sessionStorage.getItem("roles")

    const handleClose = () => {
      dispatch(closeCategoryModal(false))
    }

    if (category.modalStatus === "add") {
      content = roles?.split(",").includes("PRIV_ES_ADD_CATEGORY") ? <AddCategory handleClose={() => handleClose()} /> : null;
    } else if (category.modalStatus === "edit") {
      content = roles?.split(",").includes("PRIV_ES_EDIT_CATEGORY") ? <EditCategory handleClose={() => handleClose()} /> : null;
    } else if (category.modalStatus === "delete") {
      deleteView = true
      content = roles?.split(",").includes("PRIV_ES_DELETE_CATEGORY") ? <DeleteCategory/> : null;
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={ deleteView ? "xs" : "md" }
                open={category.modalStatus === "add" || category.modalStatus === "edit" || category.modalStatus === "delete"}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>{content}</DialogContent>
            </Dialog>
        </>
    );
};

export default CategoryDialog